<template>

  <drawer-dialog
    :value="isOpen"
    max-width="50%"
    @input="$emit('set-is-open', $event)"
  >
    <v-container
      fluid
      class="pa-0"
    >
      <v-card
        :loading="isLoading"
        class="overflow-visible"
      >
        <v-card-title
          class="notification-list-title"
        >
          Notifications
          <v-switch
            class="ml-3 mt-0"
            :input-value="mode === UNREAD"
            :label="mode === UNREAD ? 'Unread' : 'All'"
            :loading="isLoading"
            color="primary"
            hide-details
            @change="$emit('toggle-mode', $event ? UNREAD : ALL)"
          />
          <v-btn
            v-if="nUnread > 0"
            class="ml-auto"
            color="primary"
            @click="$emit('ack-all')"
          >
            Mark all as read
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-list
            v-if="notifications.length"
            ref="list"
          >
            <template
              v-for="(notification, index) in notifications"
            >
              <notification
                v-bind="notification"
                :key="notification.notification_id"
                @ack-one="$emit('ack-one', notification.notification_id)"
              />
              <v-divider v-if="index < notifications.length" />

              <v-list-item
                v-if="index === notifications.length - 1 && hasMore"
                :key="-1"
                id="pagination-trigger"
              >
                <v-list-item-content>
                  <v-list-item-title>
                    Loading more...
                    <v-progress-circular
                      v-if="isLoading"
                      indeterminate
                      color="primary"
                    />
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-list>
          <template v-else-if="!isLoading">
            {{ mode === UNREAD ? 'You are all caught up!' : 'There are no notifications yet.' }}
          </template>
        </v-card-text>
      </v-card>
    </v-container>
  </drawer-dialog>
</template>

<script>
import { DrawerDialog } from '../../../components/core/DrawerDialog'
import Notification from './Notification.vue'

const UNREAD = 'unread'
const ALL = 'all'

export default {
  props: {
    /**
     * @type {import('vue').PropType<import('../../../store/modules/notification/state').Notification[]>}
     */
    notifications: {
      type: Array,
      required: true,
    },
    isLoading: Boolean,
    isOpen: Boolean,
    hasMore: Boolean,
    mode: {
      type: String,
      required: true,
    },
    nUnread: Number,
  },

  components: {
    DrawerDialog,
    Notification,
  },

  emits: ['toggle-mode', 'set-is-open', 'ack-all', 'ack-one'],

  data() {
    return {
      UNREAD,
      ALL,
      observer: {
        disconnect() {},
      }
    }
  },

  methods: {
    observeLoadMore() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.$emit('load-more')
          }
        })
      }, {
        root: document.querySelector('#drawer-dialog-root .v-dialog'),
        threshold: 1,
      })

      observer.observe(document.querySelector('#pagination-trigger'))

      return observer
    },
  },

  watch: {
    hasMore: {
      handler(is, was) {
        if (!is) {
          this.observer.disconnect()
        }

        if (is && !was) {
          this.$nextTick(() => {
            this.observer = this.observeLoadMore()
          })
        }
      },
      immediate: true,
    }
  }
}
</script>

<style lang="scss" scoped>
.notification-list-title {
  position: sticky !important;
  top: 0;
  left: 0;
  background-color: #fff;
  z-index: 1;
}
</style>
